import CustomPageList from './CustomPageList'

export default CustomPageList